module.exports = __webpack_public_path__ + "static/fonts/LT_21023.b1bd3cfc.ttf";